import { createAction } from '@reduxjs/toolkit';

import { SagaPayload } from '../api.types';
import {
  CreateReactionRequest,
  DeleteReactionRequest,
  SwitchReactionRequest,
  ViewReactionsRequest
} from './reaction.types';

export const requestCreateReaction =
  createAction<SagaPayload<CreateReactionRequest>['payload']>('request/createReaction');

export const requestViewReactions = createAction<SagaPayload<ViewReactionsRequest>['payload']>('request/viewReactions');

export const requestDeleteReaction =
  createAction<SagaPayload<DeleteReactionRequest>['payload']>('request/deleteReaction');

export const requestSwitchReaction =
  createAction<SagaPayload<SwitchReactionRequest>['payload']>('request/switchReaction');
